module.exports = __webpack_public_path__ + "static/media/PDF_98.dbdaa12c.pdf";